import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "contexts";
export const useActiveChallengesCountsKey = "Challenges/active/count";
const useActiveChallengesCount = () => {
  const { apiService } = useAppContext();
  return useQuery<number>({
    queryKey: [useActiveChallengesCountsKey],
    queryFn: async () => {
      const response = await apiService.get<number>(`/challenges/active/count`);
      return response;
    },
  });
};

export default useActiveChallengesCount;
